<div class="dialog-header" mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    {{ 'WIDGETS.SETTINGS' | translate }} - {{ 'WIDGETS.WIDGETS_TITLES.' + widget.widget_key | translate }}
    - {{ widget.title }}
</div>

<mat-dialog-content style="padding-left: 1vw; padding-right: 1vw;">
    <ng-container *ngComponentOutlet="widgetSettingsComponent; inputs: {widget:widget};"></ng-container>
</mat-dialog-content>
<app-button-group-save-cancel
        (actionEvent)="widgetsUpdateOptions($event)"
        [formState]="formState"
        data-action="widgetsUpdateOptions"
></app-button-group-save-cancel>